const ERROR_CODES_MESSAGE = {
  1000: 'El usuario no es modificable',
  1001: 'El cliente ya existe',
  1002: 'El RUT no es válido',
  1003: 'El documento no es válido',
  1004: 'No se ha podido autenticar el usuario',
  1005: 'Contraseña incorrecta',
  1007: 'Cuenta bloqueada, por favor contactá con nuestra Atención al Cliente al 29027737',
  1020: 'La dirección no es válida, por favor contactá con nuestra Atención al Cliente al 29027737',
  1021: 'No se realizan envíos a la dirección seleccionada, por favor contactá con nuestra Atención al Cliente al 29027737',
  INVALID_CHECKOUT_PARAMS: '1027',
  CHECKOUT_CART_PRICE_MISMATCH: '1022',
  CHECKOUT_SHIPPING_PRICE_MISMATCH: '1023',
  CHECKOUT_CART_EMPTY: '1024',
  CHECKOUT_INVALID_PAYMENT_TYPE: '1025',
  CHECKOUT_INVALID_SHIPPING_TYPE: '1026',
  CHECKOUT_BILLED_OR_CANCELED: '1028',
  CHECKOUT_INVALID_ADDRESS_FIELDS: '1029',
  CHECKOUT_CART_ITEM_EXCEEDED_AMOUNT: '1031',
  1035: 'La localidad que seleccionó no es válida, por favor contactá con nuestra Atención al Cliente al 29027737',
  1034: 'Cliente baneado',
  INVALID_SERVICE_INFORMATION: '1040',
  INVALID_SERVICE_ACTION: '1041',
  INVALID_INSTALLATION_ADDRESS: '1052',
  NO_INSTALLATIONS_FOR_DATE: '1053',
  GENERIC_ERROR: '2000',
  REQUIRED_DATA: '2001',
  ACCOUNT_NON_EXISTENT: '2002',
  MUST_RESET_PASSWORD: '2006',
};

const ERROR_CODES = {
  UN_MODIFIABLE_USER: '1000',
  CLIENT_ALREADY_EXISTS: '1001',
  INVALID_RUT: '1002',
  INVALID_URUGUAYAN_DOCUMENT: '1003',
  INVALID_LOGIN: '1004',
  ACTUAL_PASSWORD_INCORRECT: '1005',
  ACCOUNT_BLOCKED: '1007',
  INVALID_ADDRESS: '1020',
  NO_SHIPPING_FOR_ADDRESS: '1021',
  INVALID_CHECKOUT_PARAMS: '1027',
  CHECKOUT_CART_PRICE_MISMATCH: '1022',
  CHECKOUT_SHIPPING_PRICE_MISMATCH: '1023',
  CHECKOUT_CART_EMPTY: '1024',
  CHECKOUT_INVALID_PAYMENT_TYPE: '1025',
  CHECKOUT_INVALID_SHIPPING_TYPE: '1026',
  CHECKOUT_BILLED_OR_CANCELED: '1028',
  CHECKOUT_INVALID_ADDRESS_FIELDS: '1029',
  CHECKOUT_CART_ITEM_EXCEEDED_AMOUNT: '1031',
  CHECKOUT_INVALID_LOCALITY: '1035',
  CLIENT_BANNED: '1034',
  INVALID_SERVICE_INFORMATION: '1040',
  INVALID_SERVICE_ACTION: '1041',
  INVALID_INSTALLATION_ADDRESS: '1052',
  NO_INSTALLATIONS_FOR_DATE: '1053',
  GENERIC_ERROR: '2000',
  REQUIRED_DATA: '2001',
  ACCOUNT_NON_EXISTENT: '2002',
  MUST_RESET_PASSWORD: '2006',
};

const ERROR_STATUSES = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  PRECONDITION_FAILED: 412,
  SERVER_ERROR: 500,
};

/*
  We need this identifier since Babel and other transpilers have trouble
  setting prototypes when extending native classes like `Error`. You can read
  more here: https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work

  Since we want to support somewhat older browsers (IE 10 and 9) we can't use
  any known workarounds for this, so we manually set a name on the error we can use.
*/
const ERROR_NAME = 'ApiError';

class ApiError extends Error {
  /*
    Checks that an error is of this type. Check the comment above
    for more info on why this is done this way.
  */
  static isSameTypeAs(error) {
    return error.name === ERROR_NAME;
  }

  constructor(params) {
    super(params.message);
    this.status = params.status;
    this.code = params.code;
    this.name = ERROR_NAME;
    this.content = params.content;
  }
}

export { ApiError, ERROR_CODES, ERROR_STATUSES, ERROR_CODES_MESSAGE };



// WEBPACK FOOTER //
// ./src/models/ApiError.js